// extracted by mini-css-extract-plugin
export default {"wrapper":"Info_wrapper__bf66C","info":"Info_info__yCYIk"};